import { firebaseDb as db } from '../firebase'
import { selectContact, asyncRequest, asyncSuccess, asyncFail, cleanMessages } from '../actions'

// action types
export const ADD_CONTACT_LOG_SUCCESS = 'ADD_CONTACT_LOG_SUCCESS'
export const FETCH_CONTACT_LOGS_SUCCESS = 'FETCH_CONTACT_LOGS_SUCCESS'

// action creators
export const addContactLog = (projectId, contactLog, previousStatus = null) => {
  return dispatch => {
    dispatch(asyncRequest('addContactLog'))

    const reachedType = contactLog.data.reachedType

    if (previousStatus !== null) {
      // we have prev. status info => Contact not reached
      if (previousStatus < 11) {
        // if 'notContacted' or all possible Call attempts
        contactLog.status = previousStatus + 1
      } else if (previousStatus === 11) {
        // if 'previousStatus' and new status is 'recall', don't change anything
        contactLog.status = 11
      } else {
        contactLog.status = 14
      }
    } else {
      // Contact reached
      if (reachedType === 'recall') {
        contactLog.status = 11
      } else if (reachedType === 'appointment') {
        contactLog.status = 12
      } else if (reachedType === 'dropOff') {
        contactLog.status = 13
      } else if (reachedType === 'successfullyReached') {
        contactLog.status = 15
      }
    }

    const currentTimestamp = Date.now()
    const updatedContactFields = {
      status: contactLog.status,
      lastCallAt: currentTimestamp,
      isInCall: false
    }

    if (previousStatus !== null && contactLog.data.nextCallDate) {
      // save 'nextCallDate' specified in Contact Modal - notReached
      updatedContactFields.nextCallDate = contactLog.data.nextCallDate
    } else if (reachedType === 'recall') {
      // save recall date as 'nextCallDate' in Contact
      updatedContactFields.nextCallDate = contactLog.data.recallDate
    }

    const projectRef = db.collection('projects').doc(projectId)
    const promise1 = projectRef.collection('logs').add(contactLog)
    const promise2 = projectRef
      .collection('contacts')
      .doc(contactLog.contactId)
      .update(updatedContactFields)

    return Promise.all([promise1, promise2])
      .then(() => {
        dispatch(asyncSuccess('addContactLog', { contactLog, updatedContactFields }, null))
        dispatch(selectContact(null))
      })
      .catch(error => {
        dispatch(asyncFail('addContactLog', error))
        dispatch(cleanMessages())
      })
  }
}

export const fetchContactLogs = (projectId, contactId) => {
  return dispatch => {
    dispatch(asyncRequest('fetchContactLogs'))

    const logsRef = db
      .collection('projects')
      .doc(projectId)
      .collection('logs')
      .where('contactId', '==', contactId)
    logsRef
      .get()
      .then(logsSnap => {
        const contactLogs = {}
        logsSnap.forEach(doc => {
          contactLogs[contactId] = {
            ...contactLogs[contactId],
            [doc.id]: doc.data()
          }
        })
        dispatch(asyncSuccess('fetchContactLogs', { contactLogs }, null))
      })
      .catch(error => {
        dispatch(asyncFail('fetchContactLogs', error))
        dispatch(cleanMessages())
      })
  }
}

// export const fetchAllContactLogs = projectId => {
//   return dispatch => {
//     dispatch(asyncRequest('fetchAllContactLogs'))

//     const logsRef = db.collection('projects').doc(projectId).collection('logs')
//     logsRef
//       .get()
//       .then(logsSnap => {
//         const contactLogs = {}
//         logsSnap.forEach(doc => {
//           contactLogs[doc.data().contactId] = {
//             ...contactLogs[doc.data().contactId],
//             [doc.id]: doc.data()
//           }
//         })
//         dispatch(asyncSuccess('fetchAllContactLogs', { contactLogs }, null))
//       })
//       .catch(error => {
//         dispatch(asyncFail('fetchAllContactLogs', error))
//         dispatch(cleanMessages())
//       })
//   }
// }



// WEBPACK FOOTER //
// ./src/actions/contactLogs.js